<template>
  <section>
    <v-dialog
      v-model="isShow"
      width="400px"
      @closed="closed">
      <div class="dialog-container">
        <div class="dialog-header">
          <span>Import Block List</span>
          <font-awesome-icon
            icon="times"
            class="pointer"
            @click="handleCancel"></font-awesome-icon>
        </div>
        <div class="dialog-body">
          <el-form
            ref="form"
            :model="formData"
            :rules="rules">
            <div class="info">
              <span class="title">Block List</span>
              <el-form-item
                :rules="rules.upload"
                prop="url"
              >
                <v-upload
                  :fileData="{
                    url: formData.url,
                    thumb_url: formData.url
                  }"
                  :accept="'.xls,.xlsx'"
                  :isExcel="true"
                  :card="true"
                  :notUpload="true"
                  @uploadForm="handlerUploadSuccess"
                  @delete="handlerUploadDelete" />
              </el-form-item>
              <el-form-item
                ref="is_cover"
                class="mg-t-15"
                :rules="rules.select"
              >
                <v-radio-group
                  v-model="formData.is_cover"
                  :list="groupList"
                  block
                />
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="dialog-footer">
          <v-button
            gray
            @click="handleCancel">Cancel</v-button>
          <v-button
            green
            @click="handleSave">Save</v-button>
        </div>
      </div>
    </v-dialog>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {importBlockList,exportBlockList} from '@api/account'

export default {
  name: 'importBlockList',
  mixins: [MixinOptions,MixinRules],
  props:{
    detailData:{
      type: Object,
      default: () => {}
    },
    value:{
      type: Boolean,
      default: false
    },
    classId:{
      type:Number,
      default:0
    }
  },
  data () {
    return {
      isShow: false,

      formData:{
        upload: '',
        is_cover:0,
        url: '',
        file:''
      },
      rules:{
        file: [
          {required: true, message: this.$t('placeholder.upload'), trigger: ['change', 'blur']}
        ]
      }
    }
  },
  computed:{
    groupList(){
      return [
        {
          id:1,
          name:'Overwrite'
        },
        {
          id:0,
          name:'Merge'
        }
      ]
    }
  },
  watch:{
    value:{
      immediate:true,
      handler(val){
        this.isShow = val
      }
    },
    'fileData.thumb_url':{
      immediate: true,
      handler(val) {
        if(val) {
          this.$set(this.formData, 'thumb_url', val)
        }
      }
    },
  },
  methods: {
    handlerUploadSuccess({ file, result, otherData }) {
      const { url } = result
      this.formData.url = url
      this.formData.file = file // params 是 new FormData 對象

      this.$refs['form'].clearValidate(['url'])

    },
    handlerUploadDelete({ params, result, otherData }) {
      this.formData.url = ''
      this.formData.file = null

      this.$refs['form'].clearValidate(['url'])

    },
    changeDialog(){
      this.isShow = !this.isShow
    },
    handleCancel(){
      this.$emit('input',false)
    },
    handleSave(){
      this.$refs['form'].validate(valid => {
        if(valid){
          let params = new FormData()
          params.append('file', this.formData.file)
          params.append('class_id', this.classId)
          params.append('is_cover', this.formData.is_cover)
          this.network().importBlockList(params)
        }
      })
    },
    closed(){
      this.$refs['form'].resetFields()
    },
    network(){
      return {
        importBlockList: async (params) => {
          const {data} = await importBlockList(params)
          if(data.code == 1000){
            this.$message({
              type: 'success',
              message: 'Success'
            })
            this.handleCancel()
            this.$emit('update')
          }
        },
      }
    }
  },
}
</script>
<style lang='scss' scoped>
/deep/.el-dialog{
  box-sizing: border-box;
  border-radius: 6px;
}

.dialog-container {
  /deep/.v-upload-container {
    .upload-btn-box {
      margin-left: 0;
    }
  }
  .dialog-header {
    padding: 16px;
    background: #F6F8FA;
    border-bottom: 1px solid #E1E4E8;
    border-radius: 6px 6px 0 0;
    display: flex;
    justify-content: space-between;
    span{
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      color: #1B1F23;
      flex: none;
      order: 0;
      align-self: stretch;
      flex-grow: 0;
    }
  }
  .dialog-body{
    padding: 20px 15px;
    .info{
      .title{
        font-weight: 600;
        font-size: 14px;
        color: #24292E;
      }
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    padding-top: 0;
  }
}
</style>
